// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nd-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at 20% 0%, rgba(255, 255, 255, 0.08), transparent 36%),
    #12362c;
  color: #14241c;
  padding: 28px 16px 64px;
}

.nd-previous {
  display: grid;
  gap: 12px;
}

.nd-sheet {
  max-width: 720px;
  margin: 0 auto;
  background: #f3f6f4;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
  padding: 28px 22px 36px;
}

.nd-kicker {
  margin: 0 0 8px;
  font-family: Palatino, "Palatino Linotype", "Iowan Old Style", serif;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-size: 12px;
  color: #3d5c4f;
}

.nd-sheet h1 {
  margin: 0 0 8px;
  font-family: Palatino, "Palatino Linotype", "Iowan Old Style", serif;
  font-weight: 600;
  font-size: 34px;
  line-height: 1.1;
}

.nd-lead,
.nd-note,
.nd-error {
  margin: 0 0 16px;
  line-height: 1.45;
}

.nd-error {
  color: #9e2b2b;
}

.nd-stamp {
  display: inline-block;
  margin: 8px 0 18px;
  padding: 6px 10px;
  border: 2px solid #9e2b2b;
  color: #9e2b2b;
  font-family: Palatino, "Palatino Linotype", serif;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  transform: rotate(-2deg);
}

.nd-grid {
  display: grid;
  gap: 12px;
}

.nd-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid #d5ddd8;
}

.nd-row strong {
  display: block;
}

.nd-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.nd-actions button,
.nd-actions label,
.nd-sign button,
.nd-sheet a.nd-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  border: 1px solid #12362c;
  background: #12362c;
  color: #f3f6f4;
  padding: 8px 12px;
  font: inherit;
  cursor: pointer;
  text-decoration: none;
}

.nd-actions button.nd-btn--quiet,
.nd-sign button.nd-btn--quiet {
  background: transparent;
  color: #12362c;
}

.nd-print {
  margin: 0 0 22px;
  padding-bottom: 8px;
  border-bottom: 1px solid #d5ddd8;
}

.nd-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 18px;
  margin: 0 0 8px;
}

.nd-summary div {
  min-width: 0;
}

.nd-summary dt {
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #3d5c4f;
}

.nd-summary dd {
  margin: 2px 0 0;
}

.nd-form label {
  display: grid;
  gap: 4px;
  margin-bottom: 10px;
  font-size: 14px;
}

.nd-form input,
.nd-form select {
  font: inherit;
  padding: 8px 10px;
  border: 1px solid #b7c4bc;
  background: white;
}

.nd-pad {
  width: 100%;
  height: 140px;
  touch-action: none;
  background:
    linear-gradient(#d5ddd8, #d5ddd8) 0 78% / 100% 1px no-repeat,
    white;
  border: 1px solid #12362c;
  cursor: crosshair;
}

.nd-sign {
  margin-top: 22px;
}

.nd-bank {
  margin-top: 22px;
  padding-top: 8px;
  border-top: 1px solid #d5ddd8;
}

.nd-bank code {
  font-size: 15px;
}

@media (max-width: 640px) {
  .nd-sheet h1 {
    font-size: 28px;
  }
  .nd-row,
  .nd-summary {
    flex-direction: column;
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/newcomer/NewcomerDossierPanel.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB;;WAES;EACT,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,oEAAoE;EACpE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oEAAoE;EACpE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EACjD,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB;;SAEO;EACP,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF","sourcesContent":[".nd-page {\n  min-height: 100vh;\n  background:\n    radial-gradient(circle at 20% 0%, rgba(255, 255, 255, 0.08), transparent 36%),\n    #12362c;\n  color: #14241c;\n  padding: 28px 16px 64px;\n}\n\n.nd-previous {\n  display: grid;\n  gap: 12px;\n}\n\n.nd-sheet {\n  max-width: 720px;\n  margin: 0 auto;\n  background: #f3f6f4;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);\n  padding: 28px 22px 36px;\n}\n\n.nd-kicker {\n  margin: 0 0 8px;\n  font-family: Palatino, \"Palatino Linotype\", \"Iowan Old Style\", serif;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  font-size: 12px;\n  color: #3d5c4f;\n}\n\n.nd-sheet h1 {\n  margin: 0 0 8px;\n  font-family: Palatino, \"Palatino Linotype\", \"Iowan Old Style\", serif;\n  font-weight: 600;\n  font-size: 34px;\n  line-height: 1.1;\n}\n\n.nd-lead,\n.nd-note,\n.nd-error {\n  margin: 0 0 16px;\n  line-height: 1.45;\n}\n\n.nd-error {\n  color: #9e2b2b;\n}\n\n.nd-stamp {\n  display: inline-block;\n  margin: 8px 0 18px;\n  padding: 6px 10px;\n  border: 2px solid #9e2b2b;\n  color: #9e2b2b;\n  font-family: Palatino, \"Palatino Linotype\", serif;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  transform: rotate(-2deg);\n}\n\n.nd-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.nd-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 0;\n  border-top: 1px solid #d5ddd8;\n}\n\n.nd-row strong {\n  display: block;\n}\n\n.nd-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.nd-actions button,\n.nd-actions label,\n.nd-sign button,\n.nd-sheet a.nd-btn {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #12362c;\n  background: #12362c;\n  color: #f3f6f4;\n  padding: 8px 12px;\n  font: inherit;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.nd-actions button.nd-btn--quiet,\n.nd-sign button.nd-btn--quiet {\n  background: transparent;\n  color: #12362c;\n}\n\n.nd-print {\n  margin: 0 0 22px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #d5ddd8;\n}\n\n.nd-summary {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 18px;\n  margin: 0 0 8px;\n}\n\n.nd-summary div {\n  min-width: 0;\n}\n\n.nd-summary dt {\n  font-size: 12px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #3d5c4f;\n}\n\n.nd-summary dd {\n  margin: 2px 0 0;\n}\n\n.nd-form label {\n  display: grid;\n  gap: 4px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.nd-form input,\n.nd-form select {\n  font: inherit;\n  padding: 8px 10px;\n  border: 1px solid #b7c4bc;\n  background: white;\n}\n\n.nd-pad {\n  width: 100%;\n  height: 140px;\n  touch-action: none;\n  background:\n    linear-gradient(#d5ddd8, #d5ddd8) 0 78% / 100% 1px no-repeat,\n    white;\n  border: 1px solid #12362c;\n  cursor: crosshair;\n}\n\n.nd-sign {\n  margin-top: 22px;\n}\n\n.nd-bank {\n  margin-top: 22px;\n  padding-top: 8px;\n  border-top: 1px solid #d5ddd8;\n}\n\n.nd-bank code {\n  font-size: 15px;\n}\n\n@media (max-width: 640px) {\n  .nd-sheet h1 {\n    font-size: 28px;\n  }\n  .nd-row,\n  .nd-summary {\n    flex-direction: column;\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
